/**
 * This file is for the JS used on all non PublicPage pages.
 */
import { createApp } from 'vue'
import ThankboxInfoTooltip from '@/components/ThankboxInfoTooltip.vue'
import FloatingVue from 'floating-vue'
import GiftCardBrowser from './components/GiftCardBrowser.vue'
import PricingTypePicker from '@/components/PricingTypePicker.vue'
import PackPricingBox from '@/components/PackPricingBox.vue'
import BusinessContactForm from '@/components/BusinessContactForm.vue'
import GenerateMessageForm from '@/components/GenerateMessageForm.vue'

createApp({})
    .use(FloatingVue, {
        autoHide: true,
        themes: {
            tooltip: {
                delay: {
                    show: 100,
                    hide: 0,
                },
            },
        },
    })
    .component('thankbox-info-tooltip', ThankboxInfoTooltip)
    .component('gift-card-browser', GiftCardBrowser)
    .component('pricing-type-picker', PricingTypePicker)
    .component('pack-pricing-box', PackPricingBox)
    .component('business-contact-form', BusinessContactForm)
    .component('generate-message-form', GenerateMessageForm)
    .mount('main')
